
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
} from '../ui/ot'
import { useTranslation } from 'react-i18next';

const HolidayListForm = ({
    propsForm,
    field,
    keyPrefix = "shift_management.holiday_overview.detail",
    dateRange,
    onFormFinish = () => { },
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const { t } = useTranslation("translation", { keyPrefix });

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };
    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                setFieldValue={setFieldValue}
                                dateRange={dateRange}
                                t={t}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    dateRange,
    getAnyFormValue,
    count,
    setFieldValue,
    t
}) => {
    return (
        <>
            <Row>
                <Col span={24} >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'holiday_setting_holiday_id']}
                        fieldKey={[field?.fieldKey ?? '', 'holiday_setting_holiday_id']}
                    >
                    </Form.Item>
                </Col>
                <Col span={24} >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'date']}
                        fieldKey={[field?.fieldKey ?? '', 'date']}
                        label={t('holiday_date')}
                        rules={[{ required: true, message: t('please_enter')  }]}

                    >
                        <Input type="date" {...dateRange} />
                    </Form.Item>
                </Col>
                <Col span={24} >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        label={t('holiday_name')}
                        name={[field?.name ?? '', 'description']}
                        fieldKey={[field?.fieldKey ?? '', 'description']}
                        rules={[{ required: true, message: t('please_enter') }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};





export default HolidayListForm;
